import {filter, from, mergeMap, Observable} from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {reset, clearFiles, resetUpload, clearThumbnails} from "../slices";

export const resetEpic = (
  action$: Observable<Action>
) => {
  return action$.pipe(
    filter(reset.match),
    mergeMap(() => {
      return from([clearFiles(), resetUpload(), clearThumbnails()]);
    })
  );
};
